export default __webpack_public_path__ + "static/media/wide-shoulders.63d2ea99.png";